import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, first, tap, map } from 'rxjs';
import { LeadInjectorAction } from 'src/app/core/events/lead-injector.actions';
import { FacebookFormConfiguration, FacebookFormLogs } from 'src/app/core/models/social-forms-configurations/facebook-form-configuration.model';
import { FacebookProxyService } from 'src/app/infrastructure/lobby-proxy/lobby-proxy-facebook/facebook-proxy.service';
import { facebookConfigurationDtoToFacebookForm, facebookConfigurationTofacebookConfigurationUpdateDto, facebookConfigurationTofacebookConfigurationCreateDto } from 'src/app/shared/mappings/facebook-model-dto/facebook-configuration-dto.mapping';
import { webhooksBatchDtoToFacebookFormLogs } from 'src/app/shared/mappings/facebook-model-dto/facebook-log-dto.mapping';
import { throwIfLobbyErrorCode } from 'src/app/shared/utils/pipes/throwIfLobbyErrorCode.pipe';

@Injectable({
  providedIn: 'root'
})
export class SocialFormsFacebookService {

  constructor(
    private readonly appStore: Store,
    private readonly facebookProxyService: FacebookProxyService) { }

  searchFacebookForms$(pageIndex: number = 0,
    pageSize: number = 20,
    isEnabled: boolean | null = null,
    leadInjectorId: number | null = null,
    formId: string | null = null,
    formName: string | null = null): Observable<FacebookFormConfiguration[]> {

    return this.facebookProxyService.searchFacebookForms$(pageIndex, pageSize, isEnabled, leadInjectorId, formId, formName).pipe(
      first(),
      throwIfLobbyErrorCode,
      //tap(data => console.log('data', data)),
      map(dto => dto.data.map(form => facebookConfigurationDtoToFacebookForm(form)!)),
      //tap(data => console.log('mapped', data)),
    )

  }

  getFacebookForm$(id: number): Observable<FacebookFormConfiguration> {
    return this.facebookProxyService.getFacebookForm$(id).pipe(
      first(),
      throwIfLobbyErrorCode,
      map(dto => facebookConfigurationDtoToFacebookForm(dto.data)!),
    )
  }

  updateFacebookForm$(id: number, configuration: FacebookFormConfiguration): Observable<void> {
    return this.facebookProxyService.updateFacebookForm$(id, facebookConfigurationTofacebookConfigurationUpdateDto(configuration)!).pipe(
      first(),
      tap(() => this.appStore.dispatch(LeadInjectorAction.socialFormFacebookConfigurationModified(id))),
      throwIfLobbyErrorCode,
      map(dto => void 0),
    )
  }

  createFacebookForm$(configuration: FacebookFormConfiguration): Observable<FacebookFormConfiguration> {
    return this.facebookProxyService.createFacebookForm$(facebookConfigurationTofacebookConfigurationCreateDto(configuration)!).pipe(
      first(),
      throwIfLobbyErrorCode,
      tap(() => this.appStore.dispatch(LeadInjectorAction.socialFacebookFormConfigurationCreated(configuration.id))),
      map(dto => facebookConfigurationDtoToFacebookForm(dto.data)!)
    )
  }

  deleteFacebookForm$(id: number) {
    return this.facebookProxyService.deleteFacebookForm$(id).pipe(
      first(),
      throwIfLobbyErrorCode,
      tap(() => this.appStore.dispatch(LeadInjectorAction.socialFacebookFormConfigurationDeleted(id))),
      map(dto => void 0),
    )
  }

  searchFormLogs$(
    formId: string,
    pageIndex: number = 0,
    pageSize: number = 20,
    configurationId: number | null = null): Observable<FacebookFormLogs[]> {

    return this.facebookProxyService.searchLogs$(pageIndex, pageSize, configurationId).pipe(
      first(),
      throwIfLobbyErrorCode,
      tap(data => console.log('data', data)),
      map(dto => dto.data.map(log => webhooksBatchDtoToFacebookFormLogs(log, formId)!)),
      tap(data => console.log('mapped', data)),
    )

  }

}
